<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="container col-lg-8 col-sm-12">
        <h2 class="mt-5 pb-3">Edit Interview Format Basic Details</h2>
        <InterviewFormatForm
          :interviewFormat="interviewFormat"
          ref="interviewFormatForm"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import {
  EDIT_INTERVIEW_FORMAT,
  FETCH_INTERVIEW_FORMAT_FILES,
  FETCH_BOOKING_INTERVIEW_FORMATS
} from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import InterviewFormatForm from "@/views/bookings/BookingInterviews/components/InterviewFormatForm";

const { mapActions: mapInterviewActions } = createNamespacedHelpers(
  INTERVIEWS_NAMESPACE
);

export default {
  name: "EditInterviewFormatBasicDetailsDialog",
  props: {
    interviewFormat: Object,
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    InterviewFormatForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Basic Details"
      };
    },
    currentBookingId() {
      return this.$route.params.id;
    },
    interviewFormatId() {
      return this.interviewFormat.id;
    }
  },
  methods: {
    ...mapInterviewActions({
      editInterviewFormat: EDIT_INTERVIEW_FORMAT,
      fetchInterviewFormatFiles: FETCH_INTERVIEW_FORMAT_FILES,
      fetchInterviewFormats: FETCH_BOOKING_INTERVIEW_FORMATS
    }),
    getInterviewEditedDetails() {
      const {
        interviewerDetails,
        candidateDetails,
        interviewName,
        duration
      } = this.$refs.interviewFormatForm.interviewFormatData;

      return {
        interviewerDetails,
        candidateDetails,
        interviewName,
        duration
      };
    },
    async handleSubmit() {
      const isValid = await this.$refs.interviewFormatForm.isFormValid();
      if (isValid) {
        this.isLoading = true;
        await this.editInterviewFormat({
          interviewDetails: this.getInterviewEditedDetails(),
          id: this.interviewFormat.id
        });
        await this.$refs.interviewFormatForm.removeFiles();
        await this.$refs.interviewFormatForm.uploadFiles(
          this.interviewFormatId
        );
        this.fetchInterviewFormats({
          bookingId: this.currentBookingId,
          withInclude: true
        });
        this.close();
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
